export const ROUTE_MODE_LEAVE_REQUEST_EVENT = 'route-mode-leave-request'

export interface RouteModeLeaveRequestDetail {
  resolve: (canLeave: boolean) => void
}

export const requestRouteModeLeave = (): Promise<boolean> => {
  if (typeof window === 'undefined') return Promise.resolve(true)

  return new Promise((resolve) => {
    let resolved = false
    const resolveOnce = (canLeave: boolean) => {
      if (resolved) return
      resolved = true
      resolve(canLeave)
    }

    const event = new CustomEvent<RouteModeLeaveRequestDetail>(ROUTE_MODE_LEAVE_REQUEST_EVENT, {
      cancelable: true,
      detail: { resolve: resolveOnce },
    })

    window.dispatchEvent(event)
    if (!event.defaultPrevented) {
      resolveOnce(true)
    }
  })
}
